<template>
    <div @mouseover="triggered = true" @mouseleave="triggered = false">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="37"
            height="40"
            viewBox="0 0 76 82"
            fill="none"
        >
            <g>
                <rect
                    v-for="(bar, index) in bars"
                    :key="index"
                    :x="bar.x.toString()"
                    :y="bar.y.toString()"
                    :height="bar.height.toString()"
                    width="12"
                    rx="6"
                    fill="#CDEB09"
                />
            </g>
            <defs>
                <clipPath id="clip0_13993_43299">
                    <rect width="76" height="82" fill="white" />
                </clipPath>
            </defs>
        </svg>
    </div>
</template>
<script>
    import { useAnimatedLogo } from '@/composables/ui/useAnimatedLogo'

    export default {
        name: 'AnimatedLogo',
        setup() {
            const { bars, triggered, animate } = useAnimatedLogo()

            return {
                bars,
                triggered,
                animate
            }
        },
        async mounted() {
            if (this.triggered) await this.animate()
        }
    }
</script>
